import _ from 'underscore';
import moment from 'moment';
import templateStr from 'text!./cancel-policy.html';
import 'portalConfig';
import DateUtil from 'gw-portals-util-js/DateUtil';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            period: '=',
            hideForm: '&'
        },

        controller: ['$scope', 'PolicyService', 'UserService', 'CancellationService', '$window', '$q', 'ModalService', 'ViewModelService', '$state', '$filter', '$rootScope', '$translate', function ($scope, PolicyService, UserService, CancellationService, $window, $q, ModalService, ViewModelService, $state, $filter, $rootScope, $translate) {
            // Create source Typelist - either insured or CancellationSource Typelist
            // Get Cancellation Source anytime the Source type list is changed.
            // Get Refund code if other 2 are ok based on PeriodStart Date
            $scope.cancellation = {
                'cancellationSource': '',
                'cancelReasonCode': '',
                'description': '',
                'cancellationRefundMethod': '',
                'effectiveDate': '',
                'isTempCancellation': null
            };
            // set up effectiveDateValidation Object
            $scope.effectiveDateValidation = {
                'isValid': true,
                'validationErrorMessage': ''
            };

            console.log("period details");
            console.log($scope.period);
            // create the cancellationView model
            $scope.cancellationView = ViewModelService.create($scope.cancellation, 'pc', 'edge.capabilities.gateway.job.cancellation.dto.CancellationDTO');
            //setup type list values..
            $scope.cancellationView.cancellationSource = _.find($scope.cancellationView.cancellationSource.aspects.availableValues, {
                code: 'insured'
            });

            $scope.acccessingXCenter = false;
            $scope.reasonCodes = $scope.cancellationView.cancelReasonCode.aspects.availableValues;
            console.log($scope.reasonCodes);
            // Temporarliy remove Policy not taken reason, due to the fact for this reason, the cancellation date must be set to the effective date
            // and this can conflict with our custom 7 days back cancellation date validation. 
            // Alternatively, we could not enforce the custom 7 days back cancellation date validation for Policy not taken in $scope.validateEffectiveDate.                             
            /**
             * Enabled "Employer request - No further information" and hid the "Cancel/Rewrite" for DEF3010
             */

            $scope.reasonCodes = _.reject($scope.reasonCodes, function (val, key) {
                return val.code == 'nottaken' || val.code == 'WritteninError' || val.code == 'MSFRewrite_Ext';
            });
            console.log($scope.reasonCodes);
            $scope.refundMethods = $scope.cancellationView.cancellationRefundMethod.aspects.availableValues;
            var currentDate = PolicyService.getCurrentDate();
            currentDate.then(function (res) {
                $scope.today = new Date(res);
                console.log("today-->");
                console.log($scope.today);
                console.log("effectiveDate-->");
                console.log($scope.effectiveDate);
                $scope.earliestCancellationDate = new Date($scope.effectiveDate);
                console.log("earliestCancellationDate-->");
                console.log($scope.earliestCancellationDate);
                $scope.earliestCancellationDate.setDate($scope.earliestCancellationDate.getDate() + 1);
                [$scope.today, $scope.earliestCancellationDate].forEach(function (date) {
                    return date.setHours(0, 0, 0, 0);
                });
            });
            /**
            * Function to check if the cancellation Reason code was modified.
            * @params{void}
            * @returns{void}
            * @private
            **/
            function reasonChanged() {
                if ($scope.cancellation.cancelReasonCode !== '') {
                    $scope.cancellation.cancellationRefundMethod = '';
                    getRefundMethods();
                }
            }
            /**
             * Function to retrieve cancellation refund methods.
             * @params{void}
             * @returns{void}
             * @private
             **/
            function getRefundMethods() {
                var tempCancellation = {
                    'cancellationSource': $scope.cancellation.cancellationSource,
                    'cancelReasonCode': $scope.cancellation.cancelReasonCode,
                    'isTempCancellation': true
                };
                /**
                  * Function to retrieve cancellation refund methods.
                  * @params{String, Object} - policyNumber, tempCancellation Object that contains Source, reasonCode and a flag.
                  * @returns{Array} - cancel refund methods
                  * @private
                  **/
                var refundMethodPromise = CancellationService.getRefundMethods($scope.period.policyNumber, tempCancellation);
                refundMethodPromise.then(function (methods) {
                    $scope.refundMethods = _.filter($scope.cancellationView.cancellationRefundMethod.aspects.availableValues, function (x) {
                        return methods.indexOf(x.code) !== -1;
                    });
                });
            }

            /**
             * Function to retrieve effective date for cancellation.
             * @params{void}
             * @returns{void} - update $scope.cancellation.effectiveDate value.
             * @private
             **/
            function getEffectiveDateForCancellation() {
                var tempCancellation = {
                    'cancellationSource': $scope.cancellation.cancellationSource,
                    'cancelReasonCode': $scope.cancellation.cancelReasonCode,
                    'cancellationRefundMethod': $scope.cancellation.cancellationRefundMethod,
                    'isTempCancellation': true
                };
                var effectiveDatePromise = CancellationService.getEffectiveDateForCancellation($scope.period.policyNumber, tempCancellation);
                //set effectiveDate value
                effectiveDatePromise.then(function (effectiveDate) {
                    $scope.cancellation.effectiveDate = effectiveDate;
                });
            }
            /**
            * Watch to keep track of effectiveDate value
            * @params{effectiveDate}
            * @returns{void}
            * @private
            **/
            //Cancellatin Date error
            $scope.$watch("cancellationView.effectiveDate.value", function (effectiveDate) {
                $scope.getRefundMethod(effectiveDate);
            });

            /**
            * Function to retrieve refund Methods based on effectiveDates for cancellation transaction.
            * @params{void}
            * @returns{void}
            * @private
            **/
            $scope.getRefundMethod = function (effectiveDate) {
                if (effectiveDate != "" && effectiveDate != null) {
                    var cancellationEffDate = moment(effectiveDate).format('YYYY-MM-DD');
                    //DEF0944-Regression-PE-Regression-Cancellation is using renewal policy term instead of current in force policy term to schedule cancellation
                    $scope.period.effective = moment($scope.period.effective).format('YYYY-MM-DD');
                    $scope.refundMethodPromise = CancellationService.getRefundValue(cancellationEffDate, $scope.period.effective, $scope.period.policyNumber);
                    $q.when($scope.refundMethodPromise, function (res) {
                        $scope.cancellationView.cancellationRefundMethod.value = res;
                    });
                }
            };
            /**
              * Function to start cancellation action
              * @params{Object} - Form that contains valuable cancellation information to start cancellation process in PC.
              * @returns{void}
              * @private
              **/
            $scope.startCancellation = function (form) {
                form.submitted = true;
                $rootScope.policyNumber = $scope.period.policyNumber;
                $scope.validateEffectiveDate();
                if (!form.invalid && $rootScope.effectiveDateValidationisValid == false && $scope.effectiveDateValidation.isValid != false) {
                    var message = $translate('gateway.views.cancellation-detail.You won\'t be able to undo once bound.').then(function (msg) {
                        return $translate('gateway.views.cancellation-detail.Are you sure you want to bind this cancellation?').then(function (secondMsg) {
                            return msg + ' ' + secondMsg;
                        });
                    });
                    var modalPromise = ModalService.showConfirm('gateway.views.cancellation-detail.Bind Cancellation', message, undefined, $filter('translate')('gateway.views.cancellation-detail.Bind Cancellation'), undefined, $filter('translate')('gateway.views.cancellation-detail.Do Not Bind')).result;

                    modalPromise.then(function () {
                        $scope.disableCancel = true;
                        $scope.cancellationPromise = CancellationService.startCancellation($scope.period.policyNumber, $scope.cancellation);
                        $q.when($scope.cancellationPromise, function (job) {
                            /*
                                * Bind Cancellation after quoting - new work flow-DEF0725 
                             */
                            $scope.bindCancellationPromise = CancellationService.bindCancellation(job.jobNumber).then(function (cancellation) {
                                PolicyService.createActivityForPortalChanges($scope.period.policyNumber, $scope.cancellation.effectiveDate, null, 'cancelledPolicy', $scope.cancellation.cancelReasonCode, $scope.cancellation.description);
                                $scope.disableCancel = false;
                                $state.transitionTo('cancellation.detail.summary', { cancellationNumber: job.jobNumber });
                            }, function () {
                                ModalService.showError('gateway.views.modal.Error', 'gateway.views.cancellation-detail.Failed to bind cancellation').result.then(function () {
                                    $scope.disableCancel = false;
                                    $scope.hideForm();
                                });
                            });
                        }, function (error) {

                            if (error.baseError.data && error.baseError.data.error.message) {
                                ModalService.showError('Error', $q.when(error.baseError.data.error.message)).result.then(function () {
                                    $scope.disableCancel = false;
                                    $scope.hideForm();
                                });
                            }
                            if (error.baseError.error.message) {
                                $scope.disableCancel = true;
                                ModalService.showError('', $q.when(error.baseError.error.message)).result.then(function () {
                                    $scope.disableCancel = false;
                                    $scope.hideForm();
                                });
                            }
                        });
                    });
                }
            };
            /**
             * Function for validating effective date. If effective date retrieved from $scope object is not valid, exit from function.
             * @params{void}
             * @returns{void}
             * @private
             **/
            $scope.validateEffectiveDate = function () {
                var latestPeriodExpiryDate = moment($scope.period.expiration).startOf('day');
                console.log('expiry date' + $scope.policy);
                var latestPeriodEffectiveDate = moment($scope.period.effective).startOf('day');
                var choosenEffectiveDate = moment($scope.cancellation.effectiveDate);
                console.log($scope.cancellation.effectiveDate);
                if ($scope.cancellation.effectiveDate == "") {
                    $scope.effectiveDateValidation.isValid = false;
                    $scope.effectiveDateValidation.validationErrorMessage = '';
                    return;
                }
                var currentDate = PolicyService.getCurrentDate();
                currentDate.then(function (res) {
                    var splited_currentDate = res.match(/(\d+)/g);
                    $rootScope.effectiveDateValidationisValid = false;
                    var sevenDaysBack = new Date(splited_currentDate[0], splited_currentDate[1] - 1, splited_currentDate[2] - 7, splited_currentDate[3], splited_currentDate[4], splited_currentDate[5]);
                    if (choosenEffectiveDate.isBefore(sevenDaysBack)) {
                        $scope.effectiveDateValidation.isValid = false;
                        $rootScope.effectiveDateValidationisValid = true;
                        $scope.effectiveDateValidation.validationErrorMessage = $filter('translate')('gateway.directives.cancel-policy.Please set a date that is no more than 7 days ago');
                        return;
                    }
                });
                if (choosenEffectiveDate.isBefore(latestPeriodEffectiveDate)) {
                    $scope.effectiveDateValidation.isValid = false;
                    $scope.effectiveDateValidation.validationErrorMessage = $filter('translate')('gateway.directives.cancel-policy.Please set a date that is on or after the start date of the policy');
                    return;
                }
                if (!choosenEffectiveDate.isBefore(latestPeriodExpiryDate)) {
                    console.log('latestPeriodExpiryDate' + latestPeriodExpiryDate);
                    $scope.effectiveDateValidation.isValid = false;
                    $scope.effectiveDateValidation.validationErrorMessage = $filter('translate')('gateway.directives.cancel-policy.Please set a date that is before the expiry date of the policy');
                    return;
                }
                $scope.effectiveDateValidation.isValid = true;
                $scope.effectiveDateValidation.validationErrorMessage = '';
            };
            /**
            * Watch to keep track of effectiveDate ( validated) Object
            * @params{validateEffectiveDate}
            * @returns{void}
            * @private
            **/
            $scope.$watch('cancellation.effectiveDate', $scope.validateEffectiveDate);
            /**
            * Watch to keep track of cancelReasonCode value
            * @params{reasonChanged}
            * @returns{void}
            * @private
            **/
            $scope.$watch('cancellation.cancelReasonCode', reasonChanged);
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/CancelPolicyDirective/CancelPolicy.js
// module id = 1731
// module chunks = 0